import { isWeb } from '@gluestack-ui/nativewind-utils/IsWeb';
import { AccessibilityInfo, findNodeHandle } from 'react-native';

import type { Heading } from '@/components/ui/heading';

export type HeadingNode = React.ComponentRef<typeof Heading>;

/**
 * Moves a screen reader to a step's heading, so a step change is announced
 * where it happened rather than left behind the reader's last focus.
 *
 * A web heading takes focus only with a tab index, set here rather than as a
 * prop because the native heading has no such prop. Minus one keeps it out of
 * the tab order.
 */
export function focusHeading(node: HeadingNode | null) {
  if (!node) {
    return;
  }

  if (isWeb) {
    const element = node as unknown as HTMLElement;

    element.setAttribute?.('tabindex', '-1');

    element.focus?.();

    return;
  }

  const handle = findNodeHandle(node as never);

  if (handle) {
    AccessibilityInfo.setAccessibilityFocus(handle);
  }
}
